import type { PuzzleMode } from '../../engine/types';
import { PetalBoard } from './Board';
import {
  PETAL_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type PetalConfig,
  type PetalMove,
  type PetalState,
} from './logic';

export const petalMode: PuzzleMode<PetalState, PetalMove, PetalConfig> = {
  id: 'petal',
  name: 'Petal',
  tagline: 'Guess before the petals fall',
  description:
    'Guess the hidden word one letter at a time. Every wrong guess plucks a petal — reveal the whole word before they’re gone.',
  accent: 'berry',
  glyph: 'flower',
  howToPlay: [
    { title: 'Guess a letter', body: 'Tap or type a letter to see if it’s in the word.' },
    { title: 'Mind the petals', body: 'Each wrong letter plucks a petal. Run out and the flower wilts.' },
    { title: 'Reveal the word', body: 'Find every letter before the petals are gone.' },
  ],
  difficulties: PETAL_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove,
  handleKey,
  hint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: PetalBoard,
};
